import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ButtonComponent, ModalOverlayService, SlottedModalComponent } from '@woolworthsnz/styleguide';
import { RewardMessage } from '@woolworthsnz/trader-api';
import { EDRHeadingComponent } from '../../../../components';
import {
	AirNZBurnMessageData,
	QantasBurnMessageData,
	SaveForOccasionUnlockMessageData,
	VoucherEarnMessageData,
	VoucherSavedMessageData,
} from '../../../../models';
import { CelebratoryModalContent, rewardMessagesModalContent } from './celebratory-modal.component.content';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'edr-celebratory-modal',
	templateUrl: 'celebratory-modal.component.html',
	styleUrls: ['celebratory-modal.component.scss'],
	standalone: true,
	imports: [SlottedModalComponent, EDRHeadingComponent, ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EDRCelebratoryModalComponent implements OnInit {
	/**
	 * Default to voucher earned content
	 */
	public rewardMessageContent: CelebratoryModalContent = rewardMessagesModalContent.voucherEarnedContent;

	constructor(
		private modalOverlayService: ModalOverlayService,
		private datePipe: DatePipe
	) {}

	public ngOnInit(): void {
		const rewardMessage = this.modalOverlayService.state?.data as RewardMessage;

		if (!rewardMessage) {
			return;
		}

		switch (rewardMessage.type) {
			case RewardMessage.TypeEnum.VoucherEarn:
				this.rewardMessageContent = rewardMessagesModalContent.voucherEarnedContent;

				const voucherEarnedData = rewardMessage.data as VoucherEarnMessageData;
				this.rewardMessageContent.title = this.rewardMessageContent.title.replace(
					'{{voucherDollars}}',
					voucherEarnedData.currentVouchersValue.toString()
				);
				break;

			case RewardMessage.TypeEnum.VoucherSaved:
				this.rewardMessageContent = rewardMessagesModalContent.voucherSavedContent;

				const voucherSavedData = rewardMessage.data as VoucherSavedMessageData;

				// Inject the SfoA saved dollars value
				this.rewardMessageContent.title = this.rewardMessageContent.title.replace(
					'{{voucherDollars}}',
					voucherSavedData.currentVouchersSavedValue.toString()
				);

				// Inject the SfoA unlock date
				const formattedDate = this.datePipe.transform(voucherSavedData.currentUnlockDate, 'd MMM yyyy') ?? '';
				this.rewardMessageContent.message = this.rewardMessageContent.message.replace(
					'{{voucherUnlockDate}}',
					formattedDate
				);
				break;

			case RewardMessage.TypeEnum.SaveForOccasionUnlock:
				this.rewardMessageContent = rewardMessagesModalContent.saveForOccasionUnlockContent;

				const saveForOccasionUnlockData = rewardMessage.data as SaveForOccasionUnlockMessageData;
				this.rewardMessageContent.title = this.rewardMessageContent.title =
					this.rewardMessageContent.title.replace(
						'{{voucherDollars}}',
						saveForOccasionUnlockData.vouchersUnlockedValue.toString()
					);
				break;

			case RewardMessage.TypeEnum.AirnzBurn:
				this.rewardMessageContent = rewardMessagesModalContent.airNzBurnContent;

				const airNZBurnData = rewardMessage.data as AirNZBurnMessageData;
				this.rewardMessageContent.title = this.rewardMessageContent.title.replace(
					'{{airpointsDollars}}',
					airNZBurnData.airNZPointsEarned.toString()
				);
				break;

			case RewardMessage.TypeEnum.QantasBurn:
				this.rewardMessageContent = rewardMessagesModalContent.qantasBurnContent;

				const qantasBurnData = rewardMessage.data as QantasBurnMessageData;
				this.rewardMessageContent.title = this.rewardMessageContent.title.replace(
					'{{qantasPoints}}',
					qantasBurnData.qantasPointsEarned.toString()
				);
				break;

			default:
				// Not a celebratory modal message type (Impossible to happen, but hey, just added this code for completeness)
				setTimeout(() => this.close());
				break;
		}
	}

	public close(): void {
		this.modalOverlayService.close();
	}
}
